export default "__VITE_ASSET__4a6e943e__"